<template>
  <div class="button-editor">
    <div class="btn-edit-input-group align-items-center">
      <div class="form-group w-25">
        <input type="text" class="form-control custom-input"
          :placeholder="$static('message-button.text-placeholder', 'Текст кнопки')" v-model="item.text"
          @focus="$emit('resetBtnError', 'text')">
        <p class="help-text" v-if="errors.textError">
          {{ $static('message-button.necessary-text', 'Текст для кнопки обов\'язковий!') }}</p>
      </div>
      <div class="form-group w-35">
        <input type="text" class="form-control custom-input"
          :placeholder="$static('message-button.link-placeholder', 'Посилання')" v-model="item.link"
          @focus="$emit('resetBtnError', 'link')">
        <p v-if="errors.linkError" class="help-text">
          {{ $static('message-button.necessary-link', 'Посилання для кнопки обов\'язкове!') }}</p>
        <p v-if="errors.linkFormatError" class="help-text">
          {{ $static('message-button.uncorrect-link', 'Некоректне посилання!') }}</p>
      </div>


      <div class="form-group  w-25">

        <div class="option-line mt-0" style="margin-bottom: 0">
          <div class="toggle-holder">
            <div class="toggler r">
              <input type="checkbox" class="toggle-check" v-model="isWebAppLink">
              <div class="knobs"></div>
              <div class="layer"></div>
            </div>
          </div>
          <div class="option-name">{{ $static('message-button.link-type', 'Посилання для WebApp') }}</div>
        </div>
      </div>

      <div class="inline-button" style="margin-left: auto">
        <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top" style="white-space: nowrap">
          <button @click="$emit('remove')" class="btn-icon btn-rounded btn-icon-transparent btn-remove" >
            <span class="icon icon-trash"></span>
          </button>
        </Popper>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MessageButton',
  props: ['item', 'errors'],
  emits: ['remove', 'update:itemType', 'resetBtnError'],

  computed: {
    isWebAppLink: {
      get() {
        return this.item.type === "webApp";
      },
      set(value) {
        this.$emit('update:itemType', !this.isWebAppLink);
      }
    }
  }
}
</script>
